import styles from "./index.module.scss";
import { 
  CloseSvg,
} from "@/assets/icons";

type CloseButtonProps = {
  onClose: () => void;
}

const CloseButton = (props: CloseButtonProps) => {
  const {
    onClose,
  } = props;

  return (
    <button
      className={styles["close_button"]}
      onClick={onClose}
    >
      <CloseSvg></CloseSvg>
    </button>
  )
}

export default CloseButton;